import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WA_LINK = "https://wa.me/919840948482?text=" + encodeURIComponent(
  "Namaste Baeboo's Wardrobe! I'd like help picking a dress size / placing an order."
);

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 15 }}
      className="fixed bottom-6 right-6 z-[60] group"
      data-testid="whatsapp-order-float-btn"
      aria-label="Order on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl group-hover:scale-110 transition-transform duration-300">
        <MessageCircle className="w-6 h-6 fill-white" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-ink text-cream text-xs font-medium rounded-full px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Order on WhatsApp
      </span>
    </motion.a>
  );
}
